import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import StoreDescription from './StoreDescription.js';

const StoreDescriptionContainer = (_param)=>{
    var { storeName , description  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "storeName",
        "description"
    ]);
    const { getFormattedLabel  } = useIntl();
    const labels = React.useMemo(()=>({
            title: getFormattedLabel('stores.page.details.description.title', {
                labelData: {
                    store: storeName
                }
            })
        })
    , [
        storeName,
        getFormattedLabel
    ]);
    return /*#__PURE__*/ React.createElement(StoreDescription, swcHelpers.extends({
        labels: labels,
        description: description
    }, rest));
};

export { StoreDescriptionContainer as default };
//# sourceMappingURL=StoreDescriptionContainer.js.map
